angular.module('impactx.uploadservicebrowser').controller('UploadServiceBrowserListCtrl', [
    'selectedListItems',
    'FileHelperService',
    '$routeParams',
    'NewWindowService',
    'ToastService',
    'dataGen',
    'TranslationService',
    '$route',
    '$mdDialog',
    'ConfirmationService',
    '$scope',
    '$securityManager',
    '$listCache',
    '$redirect',
    UploadServiceBrowserListCtrl]);

function UploadServiceBrowserListCtrl(selectedListItems, FileHelperService, $routeParams, NewWindowService, ToastService, dataGen,
                                      TranslationService, $route, $mdDialog, ConfirmationService, $scope,
                                      $securityManager, $listCache, $redirect) {
    var ctrl = this;

    selectedListItems.clearSelectedItems();

    ctrl.openFile = function () {
        NewWindowService.openNewWindow(selectedListItems.getFirstSelectedItem().link, '_blank');
    };

    ctrl.redirectToFolder = function () {
        if (ctrl.meta.params.listConfig.filterBlocks) {
            var filterBlocks = ctrl.meta.params.listConfig.filterBlocks;
            for (var j = 0; j < filterBlocks.length; j++) {
                var filters = filterBlocks[j].filterValues;
                for (var i = 0; i < filters.length; i++) {
                    filters[i].stringValue = "";
                }
            }
        }
        $redirect.redirectTo(null, "uploadservicebrowser/" + ($routeParams.path ? ($routeParams.path + "\\") : "") + selectedListItems.getFirstSelectedItem().name);
    };

    ctrl.isFolderAndCanOpen = function () {
        if (selectedListItems.isSingleSelection()) {
            var selectedItem = selectedListItems.getFirstSelectedItem();
            if (selectedItem && selectedItem.isFolder) {
                return true;
            }
        }
        return false;
    };

    ctrl.isFileAndCanOpen = function () {
        if (selectedListItems.isSingleSelection()) {
            var selectedItem = selectedListItems.getFirstSelectedItem();
            if (selectedItem && !selectedItem.isFolder) {
                return true;
            }
        }
        return false;
    };

    ctrl.newFolder = function (event, trns) {
        $mdDialog.show({
            templateUrl: 'modules/uploadservicebrowser/templates/foldername.dialog.tmpl.html',
            controller: "FolderNameDialogCtrl",
            controllerAs: "folderNameDialogCtrl",
            targetEvent: event,
            locals: {
                header: trns.folderNameHeader,
                inputLabel: trns.folderInputLabel
            },
            clickOutsideToClose: false,
            escapeToClose: false,
            fullscreen: false
        }).then(function (folderName) {
            if (folderName) {
                var dataObject = {
                    subPath: $routeParams.path,
                    folderName: folderName
                };
                dataGen.postAsForm({}, dataObject, "/uploadservicebrowser/newfolder").then(function () {
                    $route.reload();
                    ToastService.openStandardToast(TranslationService.get('saveSuccess'));
                });
            }
        });


    };

    ctrl.register = function (event, trns) {
        $mdDialog.show({
            templateUrl: 'modules/uploadservicebrowser/templates/register.dialog.tmpl.html',
            controller: "RegisterDialogCtrl",
            controllerAs: "registerDialogCtrl",
            targetEvent: event,
            locals: {
                header: trns.registerHeader,
                inputLabel: trns.registerInputLabel
            },
            clickOutsideToClose: false,
            escapeToClose: false,
            fullscreen: false
        }).then(function () {
            var dataObject = {
                subPath: $routeParams.path
            };
            dataGen.postAsForm($scope, dataObject, "/uploadservicebrowser/register").then(function () {
                $route.reload();
                ToastService.openStandardToast($scope.trns.registerSuccess);
            });
        });
    };

    ctrl.reset = function (event, trns) {
        console.log($scope);
        $mdDialog.show({
            templateUrl: 'modules/uploadservicebrowser/templates/reset.dialog.tmpl.html',
            controller: "ResetDialogCtrl",
            controllerAs: "resetDialogCtrl",
            targetEvent: event,
            locals: {
                header: trns.registerHeader,
                inputLabel: trns.registerInputLabel
            },
            clickOutsideToClose: false,
            escapeToClose: false,
            fullscreen: false
        }).then(function () {
            var dataObject = {
                subPath: $routeParams.path
            };
            dataGen.postAsForm($scope, dataObject, "/uploadservicebrowser/reset").then(function () {
                $route.reload();
                ToastService.openStandardToast($scope.trns.resetSuccess);
            });
        });
    };

    ctrl.delete = function (event, trns) {
        ConfirmationService.showConfirmationDialog(ctrl.realDelete, event, trns.confirmDelete,
            TranslationService.get("delete"), TranslationService.get("abort"));
    };

    ctrl.realDelete = function () {
        var selectedItems = selectedListItems.getSelectedItems();
        var toDelete = [];
        for (var i = 0; i < selectedItems.length; i++) {
            toDelete.push({value: selectedItems[i].name});
        }
        var dataObject = {
            subPath: $routeParams.path,
            fileNames: toDelete
        };
        dataGen.postAsForm({}, dataObject, "/uploadservicebrowser/delete").then(function () {
            $route.reload();
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
        });
    };

    ctrl.move = function () {
        var selectedItems = selectedListItems.getSelectedItems();
        var toDelete = [];
        var dataObject = {
            subPath: $routeParams.path,
            fileNames: toDelete
        };
        dataGen.postAsForm($scope, dataObject, "/uploadservicebrowser/move").then(function () {
            $route.reload();
            ToastService.openStandardToast($scope.trns.moveSuccess);
        });
    };

    ctrl.uploadFile = function () {
        angular.element(document.querySelector('#fileInputFileBrowser')).click();
    };

    ctrl.handleFileSelect = function (evt) {
        var file = evt.currentTarget.files[0];
        $(this).val("");
        ctrl.handleFile(evt, file);
    };

    this.handleFile = function (evt, file) {
        if (!FileHelperService.checkAllowedFileWithError(file.name)) {
            return;
        }

        var fileData = {
            file: file,
            fileName: file.name,
            subPath: $routeParams.path !== undefined ? $routeParams.path : ""
        };

        dataGen.uploadFile(fileData, '/uploadservicebrowser/upload').then(function () {
            $route.reload();
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
        }, angular.noop);
    };

    ctrl.canRegister = function () {
        return impactX.isDefined($scope, 'fileBrowserListCtrl.meta.actions.hasFTPUser') &&
            !impactX.isDefined($scope, 'fileBrowserListCtrl.meta.actions.hasFTPUser.allowed');
    };

    ctrl.canReset = function () {
        return impactX.isDefined($scope, 'fileBrowserListCtrl.meta.actions.hasFTPUser') &&
            impactX.isDefined($scope, 'fileBrowserListCtrl.meta.actions.hasFTPUser.allowed');
    };

    var buttonDefinition = [{
        label: "open",
        action: ctrl.redirectToFolder,
        condition: ctrl.isFolderAndCanOpen,
        process: 'UploadServiceBrowserView'
    }, {
        label: "open",
        action: ctrl.openFile,
        condition: ctrl.isFileAndCanOpen,
        process: 'UploadServiceBrowserView'
    }, {
        label: "register",
        action: ctrl.register,
        condition: ctrl.canRegister,
        process: 'UploadServiceBrowserView'
   }, {
        label: "reset",
        action: ctrl.reset,
        condition: ctrl.canReset,
        process: 'UploadServiceBrowserView'
    }, {
        label: "move",
        action: ctrl.move,
        condition: selectedListItems.isNoSelection,
        process: 'UploadServiceBrowserEdit'
    }, {
        label: "newFolder",
        action: ctrl.newFolder,
        condition: selectedListItems.isNoSelection,
        process: 'UploadServiceBrowserEdit'
    }];

    ctrl.meta = {
        rowTemplate: 'modules/uploadservicebrowser/templates/filebrowserlist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/uploadservicebrowser/list',
        id: "filebrowserlist",
        buttonDefinition: buttonDefinition,
        fileHelperService: FileHelperService,
        valuesString: [{name: "path", value: $routeParams.path}],
        handleFileSelect: ctrl.handleFileSelect,
        mainActionFunction: {id: "upload", action: ctrl.uploadFile, icon: "mdi-upload"}
    };
    ctrl.getMeta = function () {
        return this.meta;
    };
}

angular.module('impactx.uploadservicebrowser').directive('fileChange', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var onChangeHandler = scope.$eval(attrs.fileChange);
            element.on('change', onChangeHandler);
            element.on('$destroy', function () {
                element.off();
            });

        }
    };
});

